import { z } from 'zod';

// File version schema
export const fileVersionSchema = z.object({
  id: z.string(),
  versionNumber: z.number(),
  size: z.number(),
  checksum: z.string().nullable(),
  createdAt: z.string(),
});

export type FileVersion = z.infer<typeof fileVersionSchema>;

// Response schemas
export const fileVersionsResponseSchema = z.object({
  file: z.object({
    id: z.string(),
    name: z.string(),
    currentSize: z.number(),
  }),
  versions: z.array(fileVersionSchema),
});

export type FileVersionsResponse = z.infer<typeof fileVersionsResponseSchema>;

export const versionDownloadResponseSchema = z.object({
  downloadUrl: z.string(),
});

export type VersionDownloadResponse = z.infer<typeof versionDownloadResponseSchema>;

export const restoreVersionResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  file: z.object({
    id: z.string(),
    name: z.string(),
    size: z.number(),
  }),
});

export type RestoreVersionResponse = z.infer<typeof restoreVersionResponseSchema>;
